// store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import organizationSlice from './slices/organizationSlice';
import objectSlice from './slices/objectSlice';
// ==== Zmiana w Krok 3 z:
// import formSlice from './slices/formSlice';
// na:
import formsSlice from './slices/formsSlice';
// =====
import reportSlice from './slices/reportSlice';
import appSlice from './slices/appSlice';
import nodesSlice from './slices/nodesSlice'; 


export const store = configureStore({
  reducer: {
    auth: authSlice,
    organization: organizationSlice,
    objects: objectSlice,
    // ==== Zmiana w Krok 3 z:
    //forms: formSlice,
    // na:
    forms: formsSlice,
    // =====
    reports: reportSlice,
    app: appSlice,
    nodes: nodesSlice, // DODANE
},
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // DODAJ także:
        ignoredPaths: ['nodes.expandedNodes'],
        ignoredActionTypes: ['nodes/toggleNodeExpansion'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;